import { useState } from 'react';

export enum FinancialOptions {
  ADD_ACCOUNT,
  MANUAL,
  RECOMMENDED,
}

export enum StepsForRecommended {
  CONNECT_TO_INSTITUTION,
  RECOMMENDED_SELECTION,
  ACCOUNT_ADDED,
}

export enum StepsForManual {
  MANUAL_ACCOUNT_TYPE,
  MANUAL_ACCOUNT_DETAILS,
  MANUAL_REAL_ESTATE_DETAILS,
  MANUAL_PORTFOLIO_DIVERSIFICATION,
  MANUAL_HISTORICAL_VALUES,
  MANUAL_ACCOUNT_ADDED,
}

/**
 * Tracks which step the user is on.
 */
const useAddAccountNavigation = () => {
  // Determines whether to go into Recommended or Manual workflows
  const [modalExperience, setModalExperience] =
    useState<FinancialOptions | null>(FinancialOptions.ADD_ACCOUNT);

  // Keep track of which step the user is on
  const [modalStep, setModalStep] = useState<
    StepsForManual | StepsForRecommended | null
  >();

  const updateModalExperience = (experience: FinancialOptions) => {
    setModalExperience(experience);
  };

  const updateModalStep = (
    step: StepsForManual | StepsForRecommended | null,
  ) => {
    setModalStep(step);
  };

  return {
    modalExperience,
    modalStep,
    updateModalExperience,
    updateModalStep,
  };
};

export default useAddAccountNavigation;
